/* ==========================================================================
   Sand Lark storefront fixes
   1. "Buy it now" (product page, sticky bar, Quick View) adds the item and
      goes straight to checkout instead of only opening the cart drawer.
   2. Add-to-cart failures (sold out, not enough stock) show a message
      instead of silently opening an empty or unchanged cart.
   Loaded from sections/footer.liquid. Deferred scripts run before
   DOMContentLoaded, so window.LarkvilleCart from theme.js exists by the
   time the handler below runs.
   ========================================================================== */
(function () {
  'use strict';

  var toastEl = null;
  var toastTimer = null;

  function showMessage(text) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.style.cssText = [
        'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
        'z-index:400', 'max-width:calc(100vw - 32px)', 'background:#1C1812', 'color:#FFFDF5',
        'padding:14px 20px', 'border-radius:10px', 'font-size:14px', 'line-height:1.5',
        "font-family:'Work Sans',sans-serif", 'box-shadow:0 10px 30px rgba(0,0,0,0.25)',
        'display:none', 'text-align:center'
      ].join(';');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = text;
    toastEl.style.display = 'block';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.style.display = 'none'; }, 6000);
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Sorry, this item could not be added to your cart.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function readQty(input) {
    var q = parseInt((input && input.value) || 1, 10);
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.setAttribute('data-original-label', btn.textContent);
      btn.textContent = 'Going to checkout…';
      btn.disabled = true;
    } else {
      var label = btn.getAttribute('data-original-label');
      if (label) btn.textContent = label;
      btn.disabled = false;
    }
  }

  function buyNow(btn, variantId, quantity) {
    if (!variantId) return;
    setBusy(btn, true);
    addToCart(variantId, quantity)
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        setBusy(btn, false);
        showMessage(err.message);
      });
  }

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- 1. Safer add to cart: show the error instead of failing silently ---- */
    if (window.LarkvilleCart) {
      window.LarkvilleCart.add = function (variantId, quantity) {
        return addToCart(variantId, quantity)
          .then(function (data) {
            window.LarkvilleCart.refresh();
            window.LarkvilleCart.open();
            return data;
          })
          .catch(function (err) {
            showMessage(err.message);
            return null;
          });
      };
    }

    /* ---- 2. Buy it now goes to checkout ----
       Captured on document before the theme's own handlers run, so the
       old "add to cart only" behaviour never fires. */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-buy-now], [data-sa-buynow], #qvBuyNow');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      if (btn.id === 'qvBuyNow') {
        buyNow(btn, btn.getAttribute('data-variant-id'), readQty(document.getElementById('qvQtyInput')));
        return;
      }

      var section = btn.closest('[id^="shopify-section-"]');
      if (!section) return;
      var variantInput = section.querySelector('input[name="id"]');
      var qtyInput = section.querySelector('[data-qty-input]');
      buyNow(btn, variantInput ? variantInput.value : null, readQty(qtyInput));
    }, true);
  });
})();
